var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tabs)?_c('ul',{staticClass:"tab-bar"},_vm._l((_vm.tabs),function(tab){return _c('li',{key:tab.path,staticClass:"tab-bar__item"},[_c('router-link',{staticClass:"tab-bar__button",attrs:{"to":tab.path}},[(tab.icon)?_c('font-awesome-icon',{attrs:{"icon":tab.icon}}):_vm._e(),_vm._v(" "+_vm._s(tab.title)+" ")],1)],1)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }